export const COUNTRIES_STORAGE_KEY = "countries";
export const COUNTRY_CODE_STORAGE_KEY = "country_code";
export const SELECTED_COUNTRY_STORAGE_KEY = "selected_country";

export type CachedCountry = {
  code?: string;
} & Record<string, unknown>;

export const getCachedCountries = (): CachedCountry[] => {
  const cachedCountries = localStorage.getItem(COUNTRIES_STORAGE_KEY);

  if (!cachedCountries) {
    return [];
  }

  try {
    const countries: unknown = JSON.parse(cachedCountries);

    return Array.isArray(countries) ? (countries as CachedCountry[]) : [];
  } catch {
    return [];
  }
};

export const getStoredCountryCode = (): string | null =>
  localStorage.getItem(SELECTED_COUNTRY_STORAGE_KEY) ||
  localStorage.getItem(COUNTRY_CODE_STORAGE_KEY);

export const storeCountryCode = (countryCode?: string | null): void => {
  if (!countryCode) {
    return;
  }

  localStorage.setItem(SELECTED_COUNTRY_STORAGE_KEY, countryCode);
  localStorage.setItem(COUNTRY_CODE_STORAGE_KEY, countryCode);
};

export const resolveCountryCode = (
  countries: CachedCountry[] = getCachedCountries()
): string | undefined => {
  const storedCountryCode = getStoredCountryCode();

  if (
    storedCountryCode &&
    (!countries.length || countries.some(country => country.code === storedCountryCode))
  ) {
    return storedCountryCode;
  }

  return countries[0]?.code;
};

export const ensureSelectedCountry = (
  countries: CachedCountry[] = getCachedCountries()
): string | undefined => {
  const countryCode = resolveCountryCode(countries);

  storeCountryCode(countryCode);

  return countryCode;
};
